import { cn } from "@/lib/utils";

const MAP = {
  // green / success
  Aktif: "green", Terverifikasi: "green", Disetujui: "green", "Disetujui Klien": "green",
  Lunas: "green", Terbit: "green", "Closing Finance": "green", "Siap Closing": "green",
  "Diperpanjang Penuh": "green", green: "green",
  // blue / info
  Draft: "slate", "Draft 0": "slate", "Siap Dikirim": "blue", Terkirim: "blue",
  "Dikonversi ke Invoice": "blue", "Closing Operasional": "blue", "Keluar Tambahan": "blue",
  // amber / warning
  "Menunggu Persetujuan": "amber", "Menunggu Persetujuan Internal": "amber",
  "Menunggu Persetujuan Klien": "amber", "Perlu Revisi": "amber", "Menunggu Sortir": "amber",
  "Diterima Sementara": "amber", "Dibayar Sebagian": "amber", "Pengembalian Sebagian": "amber",
  "Menunggu Final Billing": "amber", "Dikembalikan Sebagian": "amber", "Menunggu Penyelesaian": "amber",
  yellow: "amber",
  // red / danger
  Dibatalkan: "rose", "Jatuh Tempo": "rose", Kedaluwarsa: "rose", Digantikan: "rose",
  "Reject/Rusak": "rose", "Hilang/Kurang": "rose", "Belum Ada Tarif": "rose",
  "Tidak Ditagihkan": "rose", red: "rose",
};

const CLASSES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  rose: "bg-rose-50 text-rose-700 border-rose-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};

export function StatusBadge({ status, className }) {
  const tone = MAP[status] || "slate";
  return (
    <span
      data-testid={`badge-${String(status).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={cn("inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap", CLASSES[tone], className)}
    >
      {status}
    </span>
  );
}
